import { cn } from '@up2stay/up2promo-ui';
import type { ReactNode } from 'react';

import { PRODUCT_DETAIL_BODY_CLASS } from '@/core/components/products/product-detail-section-card';

type ProductsSetupStepShellProps = {
  title: string;
  description?: string;
  children: ReactNode;
  /** Extra note under the description (e.g. same type for batch). */
  footnote?: string;
  className?: string;
};

/**
 * Setup step stage — one job, breathing room. Titles stay centered on every
 * viewport; stage width comes from WizardShell `contentClassName`.
 */
export function ProductsSetupStepShell({
  title,
  description,
  children,
  footnote,
  className,
}: ProductsSetupStepShellProps) {
  return (
    <div
      className={cn(
        'mx-auto flex w-full flex-col gap-6 sm:gap-7 md:gap-8',
        className,
      )}
    >
      <header className="mx-auto flex w-full max-w-2xl flex-col gap-2.5 text-center lg:max-w-3xl">
        <h2 className="text-balance text-[1.375rem] font-bold leading-tight tracking-[-0.4px] text-foreground sm:text-[1.5rem] md:text-[1.625rem]">
          {title}
        </h2>
        {description ? (
          <p
            className={`${PRODUCT_DETAIL_BODY_CLASS} text-pretty text-muted-foreground md:text-[0.9375rem] md:leading-relaxed`}
          >
            {description}
          </p>
        ) : null}
        {footnote ? (
          <p className="text-[13.5px] leading-relaxed text-muted-foreground">
            {footnote}
          </p>
        ) : null}
      </header>
      <div className="flex w-full flex-col gap-5 md:gap-6">{children}</div>
    </div>
  );
}
